import React, { useEffect, useState } from "react";
import { CancelOrder, CancelOrderByAdmin, createdPass, PostOrderAdmin } from "../../../../services/OrderService";
import User, { UserRole } from "../../../../models/User";

export default function useAddOrderAdmin(props: { reload?: () => void }) {
	const addOrderAd = async (
		partnerId: number,
		timeIn: string,
		timeOut: string,
		quantity: string,
		paymentMethod: string,
		totalMoney: string,
		customerUserId: number
	) => {
		try {
			await PostOrderAdmin(partnerId, timeOut, timeIn, quantity, paymentMethod, totalMoney, customerUserId);
			props.reload?.();
		} catch (err) {
			console.error(err);
		}
	};

	return {
		addOrderAd,
	};
}
